import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'amountSummary',
})
export class AmountSummaryPipe implements PipeTransform {
  transform(value: number, ...args: unknown[]): unknown {
    if (value < 1000) {
      return value;
    } else if (value < 1000000) {
      return (value / 1000).toFixed(2) + 'K';
    } else {
      return (value / 1000000).toFixed(2) + 'M';
    }
  }
}
